import Keycloak from "keycloak-js";

var companyName = process.env.REACT_APP_LOCATION;
    var clientId = companyName === "toroslar"
    ? "osostoroslar-react"
    : companyName === "baskent"
    ? "ososbaskent-react"
    : companyName === "ayedas"
    ? "ososayedas-react"
    : ""

var keycloakUrl = process.env.REACT_APP_KEYCLOACK_URL;

const keycloak = new Keycloak({
 url: keycloakUrl,
 realm: "OsosWeb",
 clientId: clientId,
 onLoad: "checkSso"
});

export default keycloak;